// extracted by mini-css-extract-plugin
export default {"AddToCart":"AddToCart_AddToCart__T5wUW"};